/* Hadley Bricks: retirement-alerts slide-in (snippets/hb-email-popup.liquid).
   Shows once per visitor after 30 s or 50% scroll; never on cart/checkout; a dismissal
   or a sign-up is remembered in localStorage. Without JS nothing shows (it is `hidden`). */
(function () {
  'use strict';

  var KEY = 'hb-pop-v1'; // 'dismissed' | 'subscribed' | 'shown'
  var pop = document.getElementById('hb-pop');
  if (!pop) return;

  function read() {
    try { return window.localStorage.getItem(KEY); } catch (e) { return null; }
  }
  function write(v) {
    try { window.localStorage.setItem(KEY, v); } catch (e) { /* private mode: show at most per page */ }
  }

  var path = window.location.pathname;
  if (/^\/(cart|checkout|checkouts|account|challenge|password)(\/|$)/.test(path)) return;

  function open(focus) {
    pop.hidden = false;
    requestAnimationFrame(function () { pop.classList.add('is-open'); });
    if (focus) {
      var f = pop.querySelector('input[type="email"], [data-hb-pop-ok]');
      if (f) f.focus({ preventScroll: true });
    }
    document.addEventListener('keydown', onKey);
  }
  function close(remember) {
    pop.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    window.setTimeout(function () { pop.hidden = true; }, 250);
    if (remember) write(remember);
  }
  function onKey(e) {
    if (e.key === 'Escape') close('dismissed');
  }

  pop.querySelectorAll('[data-hb-pop-close]').forEach(function (b) {
    b.addEventListener('click', function () { close(pop.querySelector('[data-hb-pop-ok]') ? 'subscribed' : 'dismissed'); });
  });
  var form = pop.querySelector('form');
  if (form) form.addEventListener('submit', function () { write('subscribed'); });

  // Back from Shopify after posting THIS form (?customer_posted=true#hb-pop-form):
  // show the confirmation / error in place.
  if (window.location.hash === '#hb-pop-form') {
    if (pop.querySelector('[data-hb-pop-ok]')) write('subscribed');
    open(true);
    return;
  }
  // Already signed up through the page's own email band on this visit.
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    write('subscribed');
    return;
  }
  if (read()) return;

  var fired = false;
  var timer;
  function trigger() {
    if (fired) return;
    fired = true;
    window.clearTimeout(timer);
    document.removeEventListener('scroll', onScroll, { capture: true });
    // Never interrupt someone who is typing in another field or has a drawer/modal open.
    var active = document.activeElement;
    if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return;
    if (document.querySelector('dialog[open], .drawer[open], cart-drawer[open]')) return;
    write('shown');
    open(false);
  }
  // Horizon sometimes scrolls a wrapper (.page-wrapper) instead of the window, so listen in
  // the capture phase and measure whichever element scrolled.
  var threshold = parseFloat(pop.getAttribute('data-scroll') || '0.5');
  function onScroll(e) {
    var t = e && e.target;
    var el = t && t.nodeType === 1 ? t : document.scrollingElement || document.documentElement;
    var isRoot = el === document.scrollingElement || el === document.documentElement || el === document.body;
    var max = isRoot ? el.scrollHeight - window.innerHeight : el.scrollHeight - el.clientHeight;
    var top = isRoot ? window.scrollY : el.scrollTop;
    // Ignore small inner scrollers (carousels, drawers): only page-sized ones count.
    if (!isRoot && el.clientHeight < window.innerHeight * 0.6) return;
    if (max > 0 && top / max >= threshold) trigger();
  }
  timer = window.setTimeout(trigger, parseInt(pop.getAttribute('data-delay') || '30000', 10));
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
})();
